import {
  Input,
  Output,
  Component,
  EventEmitter,
  ViewEncapsulation,
  ViewChild
} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MatMenuTrigger } from '@angular/material/menu';
import { filter } from 'rxjs/operators';
import { LoggerService } from '@content-platform/web-angular-shared-util-logging';
import { SideNavItem } from '../sidenav-data';
import { MatSidenav } from '@angular/material/sidenav';

const HOVER_DEBOUNCE_MS = 500;

@Component({
  selector: 'app-global-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SideNavComponent {
  @Input() sideNavData: SideNavItem[];
  @Input() nonRouterLinks: SideNavItem[];
  @Input() expandOnHover = false;
  @Input() showTooltip = false;
  @Output() itemClicked = new EventEmitter<SideNavItem>();
  @Output() expanded = new EventEmitter<boolean>();
  @Output() collapsed = new EventEmitter<boolean>();
  @ViewChild('sidenav', { static: true }) sideNav: MatSidenav;
  isOpening = false;
  isClosing = false;
  isOpen = false;
  isClosed = !this.isOpen;
  extended = this.isOpen;
  currentRouterUrl = '';
  private logger: LoggerService;
  private activeMenuTrigger: MatMenuTrigger = null;

  constructor(loggerService: LoggerService, public router: Router) {
    this.logger = loggerService.instance('SideNavComponent');
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((value: NavigationEnd) => {
        this.currentRouterUrl = value.url;
      });
  }

  openedSideBar() {
    this.isOpen = true;
    this.isOpening = false;
    this.isClosing = false;
    this.isClosed = false;
  }

  closedSidebar() {
    this.isOpen = false;
    this.isOpening = false;
    this.isClosing = false;
    this.isClosed = true;
  }

  openStart() {
    this.isOpen = false;
    this.isOpening = true;
    this.isClosing = false;
    this.isClosed = false;
    this.expanded.emit(true);
  }

  closedStart() {
    this.isOpen = false;
    this.isOpening = false;
    this.isClosing = true;
    this.isClosed = false;
    this.collapsed.emit(true);
  }

  handleClick(item: SideNavItem, event?: MouseEvent, allowPropagation = false): void {
    if (event && !allowPropagation) {
      event.stopPropagation();
    }
    if (item.route) {
      this.logger.log(`Navigated to ${item.title}`, { navId: item.route });
    }
    this.itemClicked.emit(item);
    item.isActive = !item.isActive;
    if (item.nonRouterLink && this.extended) {
      this.sideNav.close();
    }
  }

  hasChildren(item: SideNavItem): boolean {
    return item && item.children && item.children.length > 0;
  }

  debounceOpenMenu(trigger: MatMenuTrigger) {
    this.activeMenuTrigger = trigger;
    setTimeout(() => {
      if (this.activeMenuTrigger === trigger) {
        this.activeMenuTrigger.openMenu();
      }
    }, HOVER_DEBOUNCE_MS);
  }

  endDebounceOpenMenu() {
    this.activeMenuTrigger = null;
  }
}
